import type { ComboboxItem } from "@mantine/core";
import { SubMeteringSystem } from "../../types/api.types";
import urls from "../../urls";

export const subMeteringConfigurationImportLogsWildcardUrl = new RegExp(
  urls.apiWithoutCamelization
    .subMeteringConfigurationImportLogs(123, { offset: 456, limit: 789 })
    .replace("123", "\\d+")
    .replace("456", "\\d+")
    .replace("789", "\\d+")
    .replace(/\//g, "/")
    .replace(/\?/g, "\\?")
);

const SYSTEM_LABELS: Record<SubMeteringSystem, string> = {
  [SubMeteringSystem.RotorsoftDrehpunkt]: "Rotorsoft (Drehpunkt)",
  [SubMeteringSystem.WisSoftenergy]: "WIS (softenergy)",
  [SubMeteringSystem.NavigatorSiemens]: "Navigator (Siemens)",
  [SubMeteringSystem.WonderWindguard]: "Wonder (Windguard)",
  [SubMeteringSystem.Qivalo]: "Qivalo",
  [SubMeteringSystem.WeoBytemee]: "Windenergie Online (Byte Mee)",
  [SubMeteringSystem.BreezeGreenbyte]: "Breeze (GreenByte)",
  [SubMeteringSystem.Wattline]: "Wattline",
  [SubMeteringSystem.Metiundo]: "Metiundo"
};

export const SYSTEMS: Array<ComboboxItem> = Object.values(
  SubMeteringSystem
).map((value) => ({
  value,
  label: SYSTEM_LABELS[value]
}));
